



































import Vue from 'vue';
import Component from "vue-class-component";
import { Prop, Ref } from "vue-property-decorator";
import VueModal from '../modal.vue';
import VueRadio from '../forms/radio.vue';
import { FlagType } from "@/types/models";
import axios from 'axios';

@Component({
  components: { 'vue-modal': VueModal, 'vue-radio': VueRadio }
})
export default class FlagModal extends Vue {
  @Ref('modal')
  readonly modal!: VueModal;

  @Prop()
  readonly url!: string;

  @Prop()
  protected metadata!: any;

  @Prop()
  readonly types!: FlagType[];

  selectedType: number | null = null;
  text: string | null = null;
  isProcessing = false;

  mounted() {
    this.modal.open();
  }

  beforeDestroy() {
    this.modal.close();
  }

  closeModal() {
    // destroy the vue listeners, etc
    this.$destroy();

    // remove the element from the DOM
    this.$el.parentNode!.removeChild(this.$el);
  }

  sendReport() {
    this.isProcessing = true;

    axios.post('/Flag', { type_id: this.selectedType, url: this.url, metadata: this.metadata, text: this.text })
      .then(() => {
        this.$notify({type: 'success', text: 'Dziękujemy za wysłanie raportu.'});
        this.closeModal();
      })
      .finally(() => this.isProcessing = false);
  }
}

